import keyMirror from 'keymirror';

export default keyMirror({
  ADDED: null,
  DESTROYED: null,
  UPDATED: null,
  MOVED: null
}, 'MULTIPLE_CHOICE_OPTION');
